import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SaleConfirmationPageRoutingModule } from './sale-confirmation-routing.module';

import { SaleConfirmationPage } from './sale-confirmation.page';

import { SalonMonsterCheckMarkLoaderModule } from '../../../components/smr-checkmark-loader/smr-checkmark-loader.module';

import { RouterModule } from '@angular/router';

import { SaleDetailsComponentModule } from 'src/app/components/sale-details/sale-details.module';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SaleConfirmationPageRoutingModule,
    SalonMonsterCheckMarkLoaderModule,
    ReactiveFormsModule,
    RouterModule,
    SaleDetailsComponentModule
  ],
  declarations: [SaleConfirmationPage]
})
export class SaleConfirmationPageModule {}
